import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

// Async thunks
export const fetchEmployeeList = createAsyncThunk(
  'employee/fetchList',
  async (params, { rejectWithValue }) => {
    try {
      return await api.getEmployeeList(params);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const searchEmployee = createAsyncThunk(
  'employee/search',
  async (empId, { rejectWithValue }) => {
    try {
      return await api.searchEmployee(empId);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchEmployeeLogs = createAsyncThunk(
  'employee/fetchLogs',
  async ({ empId, params }, { rejectWithValue }) => {
    try {
      return await api.getEmployeeLogs(empId, params);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const employeeSlice = createSlice({
  name: 'employee',
  initialState: {
    list: [],
    total: 0,
    selectedEmployee: null,
    logs: [],
    loading: false,
    error: null,
    pagination: {
      current: 1,
      pageSize: 12,
      total: 0,
    },
  },
  reducers: {
    setSelectedEmployee: (state, action) => {
      state.selectedEmployee = action.payload;
    },
    clearSelectedEmployee: (state) => {
      state.selectedEmployee = null;
      state.logs = [];
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch list
    builder
      .addCase(fetchEmployeeList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployeeList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.total = action.payload.total;
        state.pagination.total = action.payload.total;
      })
      .addCase(fetchEmployeeList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Search
    builder
      .addCase(searchEmployee.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchEmployee.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedEmployee = action.payload;
      })
      .addCase(searchEmployee.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Fetch logs
    builder
      .addCase(fetchEmployeeLogs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployeeLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.logs = action.payload.data;
      })
      .addCase(fetchEmployeeLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setSelectedEmployee, clearSelectedEmployee, setPagination, clearError } =
  employeeSlice.actions;

export default employeeSlice.reducer;
